/**
 * Redirect guests to /login while keeping the intended path in location.state.from.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { routes } from '../utils/navigation';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (isLoading) {
    return <p className="p-7 text-sm text-[var(--muted)]">{t('common.loading')}</p>;
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.login()} replace state={{ from: location.pathname }} />;
  }

  return children;
}
